module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container small"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h4', [_c('b', [_vm._v(_vm._s(_vm.title))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.onClick()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.positiveText) + " ")])])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c924a5c8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UIComponents/InfoModal.vue
// module id = 260
// module chunks = 3